module.exports = __webpack_public_path__ + "img/logoArty-2.365c3832.svg";